import {Component, OnInit, OnChanges} from "@angular/core";

import {FormGroup, FormControl, Validators} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {UserService} from "../../../shared/services/api_v1/user.service";

@Component({
    // moduleId: module.id,
    selector:'home-resetpassword-form',
    templateUrl: './home-resetpassword-form.component.html'
})
export class HomeResetpasswordComponent implements OnInit{
    form: FormGroup;

    success = false;
    submitted = false;
    button_disabled = false;

    code: string;

    constructor(private userService:UserService, private route: ActivatedRoute){}

    ngOnInit() {
        this.route.queryParams.subscribe(values => {
            this.code = values['code'] || null;
        });

        this.form = new FormGroup(
            {
                password: new FormControl('',[ Validators.required ]),
                password_again: new FormControl('',[ Validators.required ])
            }
        );
    }

    reset_password(): void {
        if(this.form.invalid || this.form.get('password').value != this.form.get('password_again').value){ return; }
        this.submitted = false;
        this.button_disabled = true;

        this.userService.reset_password(
            this.form.get('password').value,
            this.code
        )
            .then(() => {
                this.submitted = true;
                this.success = true;
                this.button_disabled = false;
            })
            .catch(error => {
                this.submitted = true;
                this.success = false;
                this.button_disabled = false;
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/front/home/resetpassword/home-resetpassword-form.component.ts